module.exports = __webpack_public_path__ + "media/images/nariz-79d98ad8481a09ad3297ea30f070834f.png";